import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumcomponent from '../../components/BreadCrumbMex/BreadCrumb';
import Page from '../../components/Page';
import { scrollTop } from '../../utils/funciones';
import Loading from '../../wrappers/Loading';

const TokenCambioInvalidoContainer = ({ loading, setLoading, addToast }) => {
  //const { addWarningToast } = useCustomToast();

  useEffect(() => {
    scrollTop();
    //addWarningToast('');
  }, []);
  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <Breadcrumcomponent
            title="Renovación revocada"
            subtitle="Renovación revocada"
          />

          <div className="row justify-content-center">
            <div className="col-sm-10 col-md-9">
              <div className="card-login-mex">
                <div className="card-login-mex-title">
                  <h1 className="font-mex ">
                    El tiempo de renovación de contraseña ha caducado
                  </h1>
                </div>
                <div className="card-login-mex-frm">
                  <div className="row justify-content-around text-center">
                    <div className=" col-md-5 col-lg-4 my-1">
                      <Link className="btn btn-mex p-3 btn-block" to="/">
                        Ir al inicio
                      </Link>
                    </div>

                    <div className="col-md-5 col-lg-4 my-1">
                      <Link
                        className="btn btn-mex p-3 btn-block"
                        to="/recuperar-contrasenia"
                      >
                        Intentar nuevamente
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default TokenCambioInvalidoContainer;
